<template>
  <div class="modal-bg">
    <div class="modal-container">
      <img src="../assets//close_circle.png" @click="sure()" />
      <div class="box">
        <div class="text">{{ getData }}</div>
        <span class="sure" @click="sure()">确认</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "modal",
  props: {
    getData: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    sure() {
      //提示弹窗关闭按钮
      this.$emit("closeTip");
    },
  },
};
</script>
<style lang="scss" scoped>
.modal-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-container {
  width: 622px;
  //   height: 350px;
  position: relative;
  z-index: 21;
  background: white;
  background-size: 100% 100%;
  padding-top: 108px;
  padding-bottom: 60px;
  //   border: 1px solid red;
}
.box {
  // border:1px solid red;
  text-align: center;
}
.text {
  font-size: 32px;
  line-height: 44px;
  padding: 0 48px;
  //   border: 1px solid red;
}
.sure {
  width: 236px;
  height: 80px;
  display: inline-block;
  line-height: 80px;
  font-size: 28px;
  background: rgba(255, 255, 255);
  border: 2px solid #231815;
  border-radius: 8px;
  margin-top: 60px;
  font-weight: bold;
  
}
img {
  width: 16px;
  height: 16px;
  position: absolute;
  top: 32px;
  right: 32px;
}
</style>
